import React from "react";
import { Flex } from "antd";
import { SmallTitle } from "components/Common/Typography/Titles";
import { SvgIcons } from "Icon/SvgIcons";

const FileProperty = ({ name, size, url }: any) => {
  const fileClick = (url: string) => {
    window.open(url, "_blank");
  };
  return (
    <Flex
      gap={12}
      align="center"
      className="w-[285px] cursor-pointer"
      onClick={() => fileClick(url)}
    >
      <span className="cursor-pointer">{SvgIcons.pdfFileType}</span>
      <Flex vertical className="flex-grow cursor-pointer">
        <SmallTitle
          text={name}
          className="overflow-hidden text-ellipsis whitespace-nowrap max-w-[150px] text-text-secondary"
          font="font-medium"
        />
        <Flex className="w-full" align="center">
          {size > 0 && <span className="text-sm text-text-tertiary w-[54px]">{size} </span>}
          <div className="py-[3px] pl-[6px] pr-2 bg-border-tertiary rounded-full w-fit gap-[3px] flex items-center">
            <span className="h-2 w-2 rounded-full bg-text-tertiary"></span>
            <span className="text-sm text-text-tertiary text-nowrap">From ATS</span>
          </div>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default FileProperty;
